import { useLazyQueryParkingVideoRecordImage } from '@services/report'
import { IconPhoto } from '@shared/icons'
import useModal from '@shared/innmaxLib/hooks/useModal'
import Modal from '@shared/Modal'
import { ModalProps, Skeleton } from 'antd'
import { isNil } from 'ramda'
import React from 'react'
import { ModalBody } from 'src/components/Modal'

const ParkingImageViewer = (
  props: {
    mainOrderNo: number | null
    title?: string | React.ReactNode
    description?: string | React.ReactNode
  } & Omit<ModalProps, 'title' | 'onCancel' | 'footer' | 'open' | 'visible'>
) => {
  const { mainOrderNo, title, description, ...others } = props

  const { visible, open, close } = useModal()

  const {
    data: imageData,
    refetch,
    loading: loadingImage,
  } = useLazyQueryParkingVideoRecordImage()

  React.useEffect(() => {
    if (mainOrderNo && visible) {
      refetch({
        mainOrderNo,
      })
    }
  }, [mainOrderNo, visible])

  return isNil(mainOrderNo) ? (
    <>-</>
  ) : (
    <>
      <IconPhoto
        onClick={() => {
          open()
        }}
      />
      <Modal
        open={visible}
        footer={null}
        title={title}
        onCancel={close}
        {...others}>
        {description ? <div className="mb-5">{description}</div> : null}
        <ModalBody>
          <div className="text-center">
            {loadingImage ? (
              <Skeleton.Image active />
            ) : (
              <img
                alt="img"
                style={{
                  maxWidth: '100%',
                }}
                src={`data:image/png;base64,${(imageData as any)?.data?.image}`}
              />
            )}
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default React.memo(ParkingImageViewer)
